import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { MoveLikedGoodsParams, MoveLikedGoodsResponse } from './types';

export const moveLikedGoods = ({
  folder_sno,
  like_snos,
  target_folder_sno,
}: MoveLikedGoodsParams) => {
  return defaultHttpClient
    .request<MoveLikedGoodsResponse>({
      method: 'PUT',
      url: '/api/v2/members/me/liked_goods/',
      data: {
        folder_sno,
        like_snos,
        target_folder_sno,
      },
    })
    .then(result => result.data);
};
